// components/maintenance/MaintenanceBanner.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import type { MaintenanceStatus } from "../../utils/maintenance";

interface MaintenanceBannerProps {
  status: MaintenanceStatus;
}

/**
 * Bandeau persistant pour les super_admin pendant qu'une maintenance est active :
 * ils passent au travers de l'écran bloquant, il ne faut pas qu'ils l'oublient.
 */
const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({ status }) => {
  const { t } = useTranslation("common");
  const scopes = status.scope
    .map((s) => t(`maintenance.scopes.${s}`))
    .join(", ");
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-2 border-b border-amber-400/40 bg-amber-500/15 px-3 py-1.5 text-xs text-amber-100"
    >
      <Wrench className="h-3.5 w-3.5" aria-hidden />
      <span className="font-semibold uppercase tracking-wide">{t("maintenance.banner_title")}</span>
      <span className="text-amber-100/80">{t("maintenance.banner_scopes", { scopes })}</span>
      {status.block_writes && (
        <span className="rounded-full bg-amber-400/20 px-2 py-0.5">
          {t("maintenance.banner_writes_blocked")}
        </span>
      )}
      <Link
        to="/settings/maintenance"
        className="underline underline-offset-2 hover:text-white"
      >
        {t("maintenance.banner_manage")}
      </Link>
    </div>
  );
};

export default MaintenanceBanner;
